package ui.server


import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.focus.*
import androidx.compose.ui.unit.*
import common.frontend.api.*
import compose.assets.*
import compose.assets.svg.*
import kotlinx.coroutines.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.*
import tk.mallumo.utils.*
import tools.*
import ui.server.detail.*
import ui.widget.*


@ComposableNavNode
@Composable
fun ServerListingUI() {
    with(ServerListingScope.rememberScope()) {
        when (val state = vm.state) {
            is DataState.Error -> ErrUI()
            is DataState.Idle,
            is DataState.Loading -> LoadingUI()

            is DataState.Result -> Content(state.nnvl)
        }
    }
}


@OptIn(ExperimentalFoundationApi::class)
@Composable
fun ServerListingScope.Content(nnvl: ServerListingScope.Wrapper) {

    val itemCreatorState = DialogState.remember()
    ItemCreatorDialog(itemCreatorState)

    Column(Modifier.fillMaxSize().padding(top = 8.dp).padding(start = 8.dp)) {
        HomeSearchUI(vm.searchFiled, label = Res.string.server_listing__search)
        Space(8.dp)
        val stateHorizontal = rememberScrollState(0)
        val itemMeasurer = ServerListingScope.headerSpecs.rememberMeasurer(16.dp)
        Box(Modifier.fillMaxSize()) {
            Box(
                Modifier.fillMaxSize()
                    .tableMeasurer(itemMeasurer)
                    .horizontalScroll(stateHorizontal)
            ) {
                LazyColumn(
                    contentPadding = PaddingValues(end = 8.dp),
                    modifier = Modifier.fillMaxHeight()
                        .width(itemMeasurer.rowWidth)
                ) {
                    stickyHeader {
                        ListingHeader(ServerListingScope.headerSpecs)
                    }
                    itemsIndexed(
                        SearchWrapper.use(
                            fields = arrayOf(
                                Io.ListingServer.Item::id,
                                Io.ListingServer.Item::idHex,
                                Io.ListingServer.Item::name
                            ),
                            items = nnvl.state,
                            query = vm.searchFiled,
                            sort = compareByDescending<ServerListingScope.Wrapper.Item> {
                                if (it.data.id == login.server.id) 1 else 0
                            }.thenByDescending {
                                if (it.data.id < 1000) Long.MAX_VALUE - it.data.id else it.data.id
                            }
                        )) { _, item ->
                        ListingDivider()
                        ListingItem(
                            item = item,
                            specs = ServerListingScope.headerSpecs,
                            background = if (login.server.id == item.data.id) MaterialTheme.colorScheme.tertiaryContainer
                            else MaterialTheme.colorScheme.surfaceContainer
                        ) {
                            nav.findRoot().navTo_ServerUI(ServerArgs(item.data.id))
                        }
                    }

                    ListingFooter()
                }
            }
            HorizontalScrollbar(
                modifier = Modifier
                    .align(Alignment.BottomStart)
                    .padding(bottom = 8.dp)
                    .fillMaxWidth(),
                adapter = rememberScrollbarAdapter(stateHorizontal)
            )
            if (vm.canAdd) {
                FloatingActionButton(
                    onClick = { itemCreatorState.show() },
                    modifier = Modifier.align(Alignment.BottomEnd)
                        .padding(24.dp)
                ) {
                    Icon(Svg.Plus, null)
                }
            }
        }
    }
}

@Composable
fun ServerListingScope.ItemCreatorDialog(state: DialogState) {
    Dialog(state) {
        val item = remember {
            ServerListingScope.Wrapper.Item(
                Io.ListingServer.Item.EMPTY
            )
        }
        val focus = remember {
            FocusRequester()
        }
        var canSave by remember { mutableStateOf(true) }
        DialogUI(
            onDismissRequest = { state.hide() },
            modifier = Modifier.align(Alignment.Center),
            confirmButton = {
                TextButton(
                    onClick = {
                        canSave = false
                        action(ServerListingVM.Action.New(item.data))
                        state.hide()
                    },
                    enabled = canSave
                ) { Text(Res.string.dialog__action_save.rememberString()) }
            },
            dismissButton = {
                TextButton(
                    onClick = { state.hide() }
                ) { Text(Res.string.dialog__action_cancel.rememberString()) }
            },

            title = { Text(Res.string.server_listing__new_title.rememberString()) }
        ) {
            TextField(
                value = item.name.text,
                modifier = Modifier.focusRequester(focus),
                leadingIcon = { Icon(Svg.Format_text, null) },
                placeholder = { Text(Res.string.server_listing__new_name_hint.rememberString()) },
                onValueChange = {
                    item.name.set(it)
                })
        }
        LaunchedEffect(Unit) {
            delay(100)
            focus.requestFocus()
        }
    }
}


